export default __webpack_public_path__ + "static/media/440.9d4dd87d.png";